import React, { useContext, useEffect, useState } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import TheUserImg from "../images/thimg.png";
import UserImg from "../images/user-1.png";
import LockIcon from "../images/lockicon.svg";
import { FaStar, FaRegStar, FaClock } from "react-icons/fa";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { Link, useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../utility/services/AuthContext";
import ApiService from "../../utility/services/ApiService";
import Functions from "../../utility/services/Functions";
import { toast } from "react-toastify";
import ConstConfig from "../../utility/configs/constConfig";
import ImageConfig from "../../utility/configs/imageConfig";
import { Badge } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import UserAvatar from "../common/UserAvatar";
import { trackScreenView, trackButtonClick, trackEvent } from "../../utility/services/analyticsService";

const TherapistDetailsPage = () => {
  const therapistId = useParams().id;
  const navigate = useNavigate();
  // LOGICAL VARIABLES

  const { user, setLoading, setAuthRole } = useContext(AuthContext);
  const isUser = user.access_token;
  const {
    consoleService,
    calculateAge,
    scheduledTimeForTherapist,
    formet_date,
    enctyptDataFun,
  } = Functions();
  const { get_therapist_full_details_for_patient } = ApiService();

  // DATA VARIABLES

  const [therapistDetails, setTherapistDetails] = useState({});
  const isTherapistDetails = Object.keys(therapistDetails).length > 0;

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  const set_login_role = () => {
    setAuthRole("Patient");
    localStorage.setItem("E_C_R_O_L_E", enctyptDataFun("Patient"));
  };

  // FUNCTIONS

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_therapist_full_details_for_patient(therapistId);

      if (res.status === 1) {
        setTherapistDetails(res.data);
        trackScreenView("therapist_profile_screen", {
          screen_name: "Therapist Profile",
          user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
          user_role: user.details?.role,
          therapist_name: res.data.name,
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  const get_experience_str = (create_date) => {
    const experience = calculateAge(create_date);
    if (experience < 1) {
      return "Less Then One Year Of Work Experience";
    } else if (experience == 1) {
      return "1 Year of Work Experience";
    } else {
      return `${experience} Years of Work Experience`;
    }
  };

  return (
    <>
      <BannerSection
        banner={Banner}
        name={"Home"}
        title={"Therapist Details"}
      />
      {isTherapistDetails && (
        <React.Fragment>
          <section className="py-5 detailsBox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="flexUser">
                    <div className="userDetails">
                      <UserAvatar
                        profileImage={therapistDetails.profile_img}
                        firstName={therapistDetails.first_name || therapistDetails.name}
                        lastName={therapistDetails.last_name}
                        size="xl"
                        className="thimg"
                        alt={`${therapistDetails.name} profile`}
                        style={{ width: '15em', height: '15em' }}
                      />
                      <div className="rightflex">
                        <div className="star">
                          <StarRatings
                            rating={parseFloat(
                              Number(therapistDetails.avrage_ratings).toFixed(1)
                            )}
                            starRatedColor="#FF674F"
                            numberOfStars={5}
                            name="rating"
                            starDimension="20px"
                            starSpacing={0}
                          />

                          <span className="mb-1">
                            {parseFloat(
                              Number(therapistDetails.avrage_ratings).toFixed(1)
                            )}
                          </span>
                        </div>
                        <h2 style={{ color: "black" }}>
                          {therapistDetails.name}{" "}
                          {therapistDetails.online_status ? (
                            <span
                              className="online"
                              style={{ backgroundColor: "#4CD964" }}
                            ></span>
                          ) : (
                            <span
                              className="online"
                              style={{ backgroundColor: "#9E9E9E" }}
                            ></span>
                          )}
                        </h2>

                        {therapistDetails.certificate_titles.map(
                          (item, index) => {
                            return <p key={index}>{item}</p>;
                          }
                        )}

                        <small>
                          {therapistDetails.language.map((item) => {
                            return (
                              <Badge bg="primary" className="me-1">
                                {item}
                              </Badge>
                            );
                          })}
                        </small>
                        {therapistDetails.license_number &&
                          therapistDetails.license_number.trim() && (
                            <p className="mt-2">
                              License Number: {therapistDetails.license_number}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        style={{ width: 200 }}
                        className="btn btnNew btn-primary"
                        onClick={() => {
                          if (isUser) {
                            navigate("/bookanappointment", {
                              state: { therapistDetails },
                            });
                          } else {
                            navigate("/login");
                            set_login_role();
                          }
                        }}
                      >
                        Book an Appointment
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5 bglight">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Bio</h2>
                  {therapistDetails.bio}
                </div>
              </div>
            </div>
          </section>
          <section className="py-5 packagebox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Available Packages</h2>
                  <ul>
                    {therapistDetails.pricing.map((item, index) => {
                      if (item.checked)
                        return (
                          <li
                            onClick={() => {
                              trackEvent("select_session_duration_cta", {
                                event_type: "item_click",
                                screen_name: "Therapist Profile",
                                user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
                                user_role: user.details?.role,
                                therapist_name: therapistDetails.name,
                                session_type: `${item.time_in_min}min`,
                                session_price: item.price,
                              });
                              if (isUser) {
                                navigate("/bookanappointment", {
                                  state: { therapistDetails, price_item: item },
                                });
                              } else {
                                navigate("/login");
                                set_login_role();
                              }
                            }}
                          >
                            <div key={index} className="package_box">
                              <h3>
                                <FaClock />{" "}
                                {scheduledTimeForTherapist(
                                  therapistDetails.pricing,
                                  item.id
                                )}
                              </h3>
                              <h3 className="mb-0">$ {item.price}</h3>
                            </div>
                          </li>
                        );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5 bglight specbox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-3">Specialty</h2>
                  <div className="d-flex align-items-center">
                    <img src={LockIcon} alt="" className="img-fluid" />
                    <div className="mb-0 ms-3 speciality_container">
                      {therapistDetails.speciality_name.map((item, index) => {
                        const start_index = 0;
                        const last_index =
                          therapistDetails.speciality_name.length - 1;

                        if (index == start_index && last_index == index) {
                          return (
                            <span key={index} className="d-block">
                              {`${item.trim()}.`}
                            </span>
                          );
                        } else if (index != last_index) {
                          return (
                            <span key={index} className="d-block">
                              {`${item.trim()},`}
                            </span>
                          );
                        } else {
                          return (
                            <span key={index} className="d-block">
                              {`${item.trim()}.`}
                            </span>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5 specbox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-3">Reviews and Ratings</h2>
                  {therapistDetails.reviews.length > 0 ? (
                    therapistDetails.reviews.slice(0, 3).map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <article className="article_detail_wrapss">
                            <div className="article_comments_thumb">
                              <UserAvatar
                                profileImage={item.profile_img}
                                firstName={item.first_name || item.name}
                                lastName={item.last_name}
                                size="md"
                                className="rounded-circle"
                                alt={`${item.name} profile`}
                              />
                            </div>
                            <div
                              className="comment-details"
                              style={{ flexGrow: 1 }}
                            >
                              <div className="comment-meta">
                                <div className="comment-left-meta">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h4 className="author-name">{item.name}</h4>
                                    <div className="comment-reply">
                                      <div className="star-rating">
                                        <StarRatings
                                          rating={parseFloat(
                                            Number(item.rating).toFixed(1)
                                          )}
                                          starRatedColor="#FF674F"
                                          numberOfStars={5}
                                          name="rating"
                                          starDimension="18px"
                                          starSpacing={0}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="comment-date">
                                    {formet_date(item.created_at)}
                                  </div>
                                </div>
                              </div>
                              <div className="comment-text">
                                <p>{item.reviews}</p>
                              </div>
                            </div>
                          </article>
                          <hr />
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <h3 className="mb-3">No Ratings</h3>
                  )}

                  {therapistDetails.reviews.length > 3 && (
                    <div className="text-center mt-4">
                      <Button
                        as={Link}
                        to={`/ratingreview/${therapistDetails._id}`}
                        className="btn btn-primary"
                      >
                        View All
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
      )}
    </>
  );
};

export default TherapistDetailsPage;
